import { useTranslation } from "react-i18next";
import { Fragment, useEffect, useRef, useState } from "react";
import apiRequest from "../../functions/api";
import {
  Paper,
  TextField,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  Hidden,
  FormControlLabel,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import BetragInput from "../shared/components/BetragInput";
import Grid from "@mui/material/Grid";
import { useMessage } from "../../context/message-context";
import VisibilityIcon from "@mui/icons-material/Visibility";
import axios from "axios";
import { API_BASE_URL } from "../../constants/apiConstants";
import { responsiveFontSizes, useTheme } from "@mui/material/styles";
import openFile from "../shared/functions/download";
import CloseIcon from "@mui/icons-material/Close";
import NewExpense from "./NewExpense";
import ExpenseMobileTable from "./ExpenseMobileTable";
import ExpenseTable from "./ExpenseTable";
import { getFile } from "./getFile";
import FormularFeld from "../Formular/FormularFeld";
function DatumsGruppe(props) {
  const { t } = useTranslation();
  //Standardfelder
  const {
    accessToken,
    client,
    element,
    program,
    ChangeFiles,
    lock,
    files,
    mehrereBelegeErlauben,
    felder,
    formular,
    felderError,
    pruefeAntworten,
    ZSpeichern,
    onChange,
    DateiLaden,
    Summe,
    uebergaben,
  } = props;
  const { showErrorMessage } = useMessage();

  const controller = useRef(new AbortController());
  const [addExpenseModal, setAddExpenseModal] = useState("");
  const [zeitraum, setZeitraum] = useState("");
  const [zeilen, setZeilen] = useState([]);
  useEffect(() => {
    if (program === "PMURA3") {
      return;
    }
    console.log(element);
    if (element.zeilen) {
      setZeilen(element.zeilen);
    }
    // eslint-disable-next-line
  }, [felder]);

  const tmparray = element.inhalt.split(";");
  var breite = 12 / tmparray.length;
  var italic = false;
  var bold = false;

  const selectZeitraum = () => {
    element.zeitraum = zeitraum;
    onChange(element.key, element, undefined);
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    const payload = {
      mandant: client,
      program: program,
      zeitraum: zeitraum,
      art: element.logik,
      statement: "DATUMSGRUPPE_SELECT_MONAT",
    };
    apiRequest("POST", "daten", payload, headers, initCB, setRedirect);
  };
  const initCB = (response) => {
    // setAufwendungen(response.data.aufwendungen)
    setZeilen(response.data.zeilen);
    element.zeilen = response.data.zeilen;

    onChange(element.key, element, undefined);
    response.data.zeilen.forEach((i, count) => {
      element?.inhalt?.split(";")?.forEach((feld) => {
        // console.log(feld,"1",i)
        if (felder[formular][feld].typ === "01") {
          onChange(feld, "", (count + 1).toString(), undefined);
        } else {
          onChange(feld, "0", (count + 1).toString(), undefined);
        }
      });
    });
  };
  const setRedirect = (path) => {
    navigate(path);
  };

  function forLoop(item, tmparray, breite) {
    var array = [];
    for (var i = 1; i <= Number(item.logik); i++) {
      array.push(i);
    }
    return (
      <Fragment>
        {array.map((i) => {
          if (i > zeilen?.length) return <Fragment />;
          const tagKennungen = zeilen?.[i - 1]?.kennungen?.split(";").filter(Boolean);
          return (
            <TableRow>
              {Number(item.logik) > 1 && (
                <TableCell>
                  {Number(item.logik) > 1 && zeilen?.length >= 1 && (
                    <Typography>
                      {zeilen?.[i - 1]?.wochentag},{zeilen?.[i - 1]?.datum}{" "}
                    </Typography>
                  )}
                </TableCell>
              )}
              {zeilen[i - 1].zukunft ? (
                <TableCell>
                  <Chip sx={{ width: "100%" }} label={"In Zukunft"}></Chip>
                </TableCell>
              ) : tagKennungen[tagKennungen.length - 1] === "FZ" ? (
                <TableCell>
                  <Chip sx={{ width: "100%" }} label={t("Urlaub")} color="primary"></Chip>
                </TableCell>
              ) : tagKennungen[tagKennungen.length - 1].includes("-FT") ? (
                <TableCell>
                  <Chip sx={{ width: "100%" }} label={zeilen?.[i - 1]?.fehlzeit} color="error"></Chip>
                </TableCell>
              ) : (
                <TableCell></TableCell>
              )}
              {tmparray.map((id, index) => {
                var locked = lock;
                if (felder[formular][id].art === "R") {
                  grpfelder.current[id] = item.key;
                }
                if (felder[formular][id].art === "R" && felder[formular][id].typ === "07") {
                  return "";
                }
                const feldLogik = felder[formular][id].logikwert.split(";").filter(Boolean);

                if (tagKennungen.some((value) => feldLogik.includes(value)) || zeilen[i - 1].zukunft) {
                  locked = true;
                }
                return (
                  <TableCell>
                    {felder[formular][id].art === "I" && (
                      <FormularFeld
                        client={client}
                        accessToken={accessToken}
                        program={program}
                        ZSpeichern={ZSpeichern}
                        key={felder[formular][id]}
                        element={felder[formular][id]}
                        onChange={onChange}
                        DateiLaden={DateiLaden}
                        files={files}
                        ChangeFiles={ChangeFiles}
                        ind={i}
                        uebergaben={uebergaben}
                        lock={lock}
                      />
                    )}
                    {felder[formular][id].art === "E" && (
                      <FormularFeld
                        client={client}
                        accessToken={accessToken}
                        program={program}
                        ZSpeichern={ZSpeichern}
                        key={felder[formular][id]}
                        element={felder[formular][id]}
                        onChange={onChange}
                        DateiLaden={DateiLaden}
                        files={files}
                        ChangeFiles={ChangeFiles}
                        ind={i}
                        gruppe={item.key}
                        Summe={Summe}
                        uebergaben={uebergaben}
                        lock={locked}
                      />
                    )}
                    {felder[formular][id].art === "R" && (
                      <FormularFeld
                        client={client}
                        accessToken={accessToken}
                        program={program}
                        ZSpeichern={ZSpeichern}
                        key={felder[formular][id]}
                        element={felder[formular][id]}
                        onChange={onChange}
                        DateiLaden={DateiLaden}
                        files={files}
                        ChangeFiles={ChangeFiles}
                        ind={i}
                        gruppe={item.key}
                        Summe={Summe}
                        uebergaben={uebergaben}
                        lock={lock}
                      />
                    )}
                  </TableCell>
                );
              })}
            </TableRow>
          );
        })}
      </Fragment>
    );
  }
  function forLoopMobil(item, tmparray, breite) {
    var bold = false;
    var italic = false;
    var array = [];
    for (var i = 1; i <= Number(item.logik); i++) {
      array.push(i);
    }
    var zeilen = pruefeAntworten(tmparray);
    return (
      <Fragment>
        {array.map((i) => {
          if (i > zeilen + 1) return <Fragment />;
          return (
            <Fragment>
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  {tmparray.map((id, index) => {
                    italic = false;
                    bold = false;
                    if (felder[formular][id].art === "I" && felder[formular][id].typ === "08") {
                      return;
                    }
                    if (felder[formular][id].art === "R" && felder[formular][id].typ === "07") {
                      return;
                    }
                    if (felder[formular][id].format && (felder[formular][id].format === "03" || felder[formular][id].format === "04")) italic = true;
                    if (felder[formular][id].format && (felder[formular][id].format === "02" || felder[formular][id].format === "04")) bold = true;
                    if (felder[formular][id].art === "R") {
                      grpfelder.current[id] = item.key;
                    }
                    return (
                      <Fragment>
                        <Grid item xs={12}>
                          {felderError.findIndex((j) => j.includes(id)) !== -1 &&
                          felderError[felderError.findIndex((j) => j.includes(id))].substr(4, 1) >= i &&
                          (!felder[formular][id].antwort || !felder[formular][id].antwort[i] || felder[formular][id].antwort[i] === "") ? (
                            <Typography
                              style={
                                bold && italic
                                  ? { fontStyle: "italic", fontWeight: "bold", color: setColor2("255100100", 1) }
                                  : bold
                                  ? { fontWeight: "bold", color: setColor2("255100100", 1) }
                                  : italic
                                  ? { fontStyle: "italic", color: setColor2("255100100", 1) }
                                  : { color: setColor2("255100100", 1) }
                              }
                            >
                              {felder[formular][id].label === "1"
                                ? ""
                                : Number(item.logik) > 1 && zeilen >= 1
                                ? felder[formular][id].name + "   ( " + i.toString() + " )"
                                : felder[formular][id].name}
                            </Typography>
                          ) : (
                            <Typography
                              style={
                                bold && italic
                                  ? { fontStyle: "italic", fontWeight: "bold" }
                                  : bold
                                  ? { fontWeight: "bold" }
                                  : italic
                                  ? { fontStyle: "italic" }
                                  : {}
                              }
                            >
                              {felder[formular][id].label === "1"
                                ? ""
                                : Number(item.logik) > 1 && zeilen >= 1
                                ? felder[formular][id].name + "   ( " + i.toString() + " )"
                                : felder[formular][id].name}
                            </Typography>
                          )}
                        </Grid>
                        <Grid item xs={12}>
                          {felder[formular][id].art === "I" && (
                            <FormularFeld
                              client={client}
                              accessToken={accessToken}
                              program={program}
                              ZSpeichern={ZSpeichern}
                              key={felder[formular][id]}
                              element={felder[formular][id]}
                              onChange={onChange}
                              DateiLaden={DateiLaden}
                              files={files}
                              ChangeFiles={ChangeFiles}
                              ind={i}
                              uebergaben={uebergaben}
                              lock={lock}
                            />
                          )}
                          {felder[formular][id].art === "E" && (
                            <FormularFeld
                              client={client}
                              accessToken={accessToken}
                              program={program}
                              ZSpeichern={ZSpeichern}
                              key={felder[formular][id]}
                              element={felder[formular][id]}
                              onChange={onChange}
                              DateiLaden={DateiLaden}
                              files={files}
                              ChangeFiles={ChangeFiles}
                              ind={i}
                              gruppe={item.key}
                              uebergaben={uebergaben}
                              lock={lock}
                            />
                          )}
                          {felder[formular][id].art === "R" && (
                            <FormularFeld
                              client={client}
                              accessToken={accessToken}
                              program={program}
                              ZSpeichern={ZSpeichern}
                              key={felder[formular][id]}
                              element={felder[formular][id]}
                              onChange={onChange}
                              DateiLaden={DateiLaden}
                              files={files}
                              ChangeFiles={ChangeFiles}
                              ind={i}
                              gruppe={item.key}
                              uebergaben={uebergaben}
                              lock={lock}
                            />
                          )}
                        </Grid>
                      </Fragment>
                    );
                  })}
                </Grid>
              </Grid>
              <hr align="center" width="100%" height="2px" color="black" />
            </Fragment>
          );
        })}
      </Fragment>
    );
  }

  const item = {
    art: element.art,
    inhalt: element.inhalt,
    logik: "31",
    name: element.name,
  };

  return (
    <Fragment>
      <Hidden mdDown>
        <Grid item xs={12}>
          <TextField label="Monat auswählen" onChange={(e) => setZeitraum(e.target.value)} value={zeitraum}></TextField>
          <Button onClick={() => selectZeitraum()}>Monat auswählen</Button>
          <Grid container spacing={0}>
            <TableContainer component={Paper}>
              <Table className={""} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="">Datum</TableCell>
                    <TableCell align="center">Fehlzeit/Feiertag</TableCell>

                    {tmparray.map((id, index) => {
                      italic = false;
                      bold = false;
                      if (felder[formular][id].art === "R" && felder[formular][id].typ === "07") {
                        return;
                      }
                      if (felder[formular][id].format && (felder[formular][id].format === "03" || felder[formular][id].format === "04")) italic = true;
                      if (felder[formular][id].format && (felder[formular][id].format === "02" || felder[formular][id].format === "04")) bold = true;
                      return (
                        <TableCell align="center"> {felder[formular][id].label === "1" ? "" : felder[formular][id].name}</TableCell>
                        // <Fragment>
                        //   <Grid item xs={12} md={breite <= 2.4 ? true : breite} align="left">
                        //     {felderError.some((i) => i.substr(0, 4) === id) && (
                        //       <Typography
                        //         fullWidth
                        //         style={
                        //           bold && italic
                        //             ? { fontStyle: "italic", fontWeight: "bold", color: setColor2("255100100", 1) }
                        //             : bold
                        //             ? { fontWeight: "bold", color: setColor2("255100100", 1) }
                        //             : italic
                        //             ? { fontStyle: "italic", color: setColor2("255100100", 1) }
                        //             : { color: setColor2("255100100", 1) }
                        //         }
                        //       >
                        //         {felder[formular][id].label === "1" ? "" : felder[formular][id].name}
                        //       </Typography>
                        //     )}
                        //     {!felderError.some((i) => i.substr(0, 4) === id) && (
                        //       <Typography
                        //         fullWidth
                        //         style={
                        //           bold && italic
                        //             ? { fontStyle: "italic", fontWeight: "bold" }
                        //             : bold
                        //             ? { fontWeight: "bold" }
                        //             : italic
                        //             ? { fontStyle: "italic" }
                        //             : {}
                        //         }
                        //       >
                        //         {felder[formular][id].label === "1" ? "" : felder[formular][id].name}
                        //       </Typography>
                        //     )}
                        //   </Grid>
                        // </Fragment>
                      );
                    })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {forLoop(item, tmparray, breite)}                  
                </TableBody>
              </Table>
            </TableContainer>

            {Number(item.logik) > 1 && <Grid item xs={1}></Grid>}
            <Grid item xs={11}>
              <Grid container spacing={1}></Grid>
            </Grid>
          </Grid>
        </Grid>
      </Hidden>
      <Hidden mdUp>{forLoopMobil(item, tmparray, breite)}</Hidden>
    </Fragment>
  );
}

export default DatumsGruppe;
